import { type UseMutationResult, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import {
  WarrantExerciseService,
  type Wealthlane_CapTable_Dtos_Warrant_RequestWarrantExerciseOnBehalfDto,
  type Wealthlane_Shared_Hosting_Dtos_GenericApiResponse,
} from '@wealthlane/api-services/wealthlane-captable-service';
import { useNavigate } from 'react-router-dom';
import ToastComponent from '../../components/toast';

const usePostRequestExerciseOnBehalf = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
  unknown,
  Wealthlane_CapTable_Dtos_Warrant_RequestWarrantExerciseOnBehalfDto,
  unknown
> => {
  const navigate = useNavigate();

  return useMutation(
    async (payload: Wealthlane_CapTable_Dtos_Warrant_RequestWarrantExerciseOnBehalfDto) => {
      return await handleRequest(
        WarrantExerciseService.postApiCapTableApiAppWarrantExerciseRequestExerciseOnBehalf(payload)
      );
    },
    {
      onSuccess: (response: any) => {
        if (response?.isSuccess) {
          toast.success(
            <ToastComponent label='Success' message='Warrant exercise requested on behalf.' />
          );
          navigate('/cap-table/warrants');
        } else {
          toast.error(
            <ToastComponent
              label='Error'
              message={response?.message || 'Exercise request failed.'}
            />
          );
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostRequestExerciseOnBehalf;
